// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\ServicesV2\Quotes\DataProviders\QuoteField
// Generated on: <normalized>

export enum QuoteField {
  DB_TABLE = 'quotes',
  DB_IDENTIFIER = 'quoteGUID',
  QUOTE_DATE = 'quoteDate',
  STATUS = 'quoteStatus',
  PARENT_GUID = 'parentGUID',
  CLIENT_GUID = 'clientGUID',
  REVENUE_STREAM_GUID = 'revenueStreamGUID',
  NET = 'net',
  TAX = 'tax',
  QUOTE_DESCRIPTION = 'quoteDescription',
  QUOTE_DETAILS = 'quoteDetails',
  PURCHASE_ORDER = 'quotePurchaseOrder',
  CONTACT_DATA = 'contactData',
  JOB_DATA = 'jobData',
  HIRE_DATA = 'hireData',
  SERVICE_TOTALS = 'serviceTotals',
  BOOLEAN_SETTINGS = 'booleanSettings',
  CONTRACT_SETTINGS = 'contractSettings',
}

export const QuoteFieldGetEncryptionFields = [] as const;

export const QuoteFieldCases = ["quotes", "quoteGUID", "quoteDate", "quoteStatus", "parentGUID", "clientGUID", "revenueStreamGUID", "net", "tax", "quoteDescription", "quoteDetails", "quotePurchaseOrder", "contactData", "jobData", "hireData", "serviceTotals", "booleanSettings", "contractSettings"] as const;
